<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="card">
        <div class="card-body">
            <div class="card-header bg-info">
                <div style="float:left;">
                    <h2><i class="fa fa-users"></i> การอนุมัติ ปุ๋ยรอบ 3 ปีการผลิต 2566/2567 (รายแปลง)</h2>
                </div>
            </div>

            <form [formGroup]="Actioncmg">
                <div class="row justify-content-md-center">
                    <div class="col-md-7">
                        <div class="card">
                            <div class="card-header">เลือกแปลงที่จะอนุมัติ ปุ๋ยรอบ3 จากแปลง
                                ({{Alldata_cp.length|number}})
                                แปลง</div>
                            <div class="card-body">
                                <div class="row justify-content-md-center">
                                    <div class="col-md-5">
                                        <mat-form-field appearance="fill">
                                            <mat-label>เลือกโซน</mat-label>
                                            <select matNativeControl formControlName="selectzone" name="abc">
                                                <option value="" selected>-- ทุกโซน --</option>
                                                <option *ngFor="let item of zonecode" [value]="item.supzone">
                                                   - {{item.supzone}} | {{item.zonename}} -
                                                </option>
                                            </select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-5">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-label>ค้นหาแปลง (เลขแปลง,ชื่อชาวไร่)</mat-label>
                                            <input matInput formControlName="term" placeholder="Search Here">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="example-button-row">
                                            <button mat-raised-button color="primary" (click)="sv_data()">ค้นหา</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-body table-responsive p-2" style="height: 550px">
                                <table class="table table-sm table-striped table-hover table-head-fixed table-bordered"
                                    style="width:100%">
                                    <thead>
                                        <tr style="text-align:center;">
                                            <th>No</th>
                                            <th>เลขแปลง</th>
                                            <th>ชื่อชาวไร่</th>
                                            <th>โซน</th>
                                            <th>พื้นที่</th>
                                            <th>ประเภทอ้อย</th>
                                            <th>ตัน/ไร่</th>
                                            <th>วันปลูก</th>
                                            <th>เบิกรอบ3</th>
                                            <th>เลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of dataResult index as i">
                                            <td style="text-align:center;">{{i+1 | number}}</td>
                                            <td>{{item.intlandno}}</td>
                                            <td>{{item.fmname}}</td>
                                            <td style="text-align:center;">{{item.supzone}}</td>
                                            <td style="text-align:right;">{{item.landvalue | number:"1.2-2"}}</td>
                                            <td style="text-align:center;">{{item.canetype}}</td>
                                            <td style="text-align:center;">{{item.ton}}</td>
                                            <td style="text-align:center;">{{item.PlantDate | adtob}}</td>
                                            <td style="text-align:left;">
                                                <label class="form-label" style="color: red;"
                                                    *ngIf="item.getFert3=='Y'">อนุมัติแล้ว</label>
                                                <label class="form-label" style="color: green;"
                                                    *ngIf="item.getFert3=='N'">ยังไม่อนุมัติ</label>

                                                <label *ngFor="let li of datafert3">
                                                    <div *ngIf="li.itid.trim() == item.itid.trim()">-{{li.getFert3 |
                                                        number }}</div>
                                                </label>
                                                <!--<div *ngFor="let li of datafert3">
                                                        <label
                                                            *ngIf="li.itid.trim() == item.itid.trim()">-{{li.getFert3 | number }}</label>
                                                    </div>-->
                                            </td>

                                            <td style="text-align:center;">
                                                <i *ngIf="item.getFert3=='N'" class='fas fa-chevron-circle-right'
                                                    style='font-size:28;color:green' (click)="getdata(item)"></i>
                                                <i *ngIf="item.getFert3=='Y'" class='fas fa-chevron-circle-right'
                                                    style='font-size:28;color:red' (click)="getdata(item)"></i>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="card" *ngIf="dataAr.length > 0">
                            <div class="card-header">รายการข้อมูลที่เลือก </div>
                            <div class="card-body">
                                <div class="row justify-content-md-center">
                                    <div class="col-sm-2">
                                    </div>
                                    <div class="col-sm-4">
                                        <button mat-raised-button color="primary" [disabled]="len_list[0]==0"
                                            (click)="save_getFert3('Y');">อนุมัติ {{len_list[0]}}
                                            รายการ</button>
                                    </div>
                                    <div class="col-sm-4">
                                        <button mat-raised-button color="warn" [disabled]="len_list[1]==0"
                                            (click)="save_getFert3('N');">ยกเลิกอนุมัติ {{len_list[1]}}
                                            รายการ</button>
                                    </div>
                                    <div class="col-sm-2">
                                        <button mat-raised-button color="accent" (click)="dataAr=[];">clear</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body table-responsive p-2" style="height: 575px">
                                <table
                                    class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap"
                                    style="width:100%" *ngIf="dataAr.length>0">
                                    <thead>
                                        <tr>
                                            <th style="text-align:center ;">No</th>
                                            <th>เลขแปลง</th>
                                            <th>ชื่อชาวไร่</th>
                                            <th>พื้นที่</th>
                                            <th style="text-align:center;">เบิกรอบ3</th>
                                            <th style="text-align:center;">.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of dataAr ; index as i">
                                            <td style="text-align:center;">{{i+1 | number}}</td>
                                            <td>{{item.intlandno}}</td>
                                            <td>{{item.fmname}}</td>
                                            <td>{{item.landvalue}}</td>
                                            <td style="text-align:center;">
                                                <label class="form-label" style="color: red;"
                                                    *ngIf="item.getFert3==='Y'">อนุมัติแล้ว</label>
                                                <label class="form-label" style="color: green;"
                                                    *ngIf="item.getFert3==='N'">ยังไม่อนุมัติ</label>
                                            </td>
                                            <td style="text-align:center;">
                                                <i class='fas fa-times' style='font-size:22px;color:red'
                                                    (click)="remove_val(item.itid);"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-body">
            <div class="card-header bg-warning">
                <div style="float:left;">
                    <h2><i class="fas fa-history"></i> รายการเบิกปุ๋ยรอบ 3 ของชาวไร่</h2>
                </div>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" (click)="fmgetFactor();"><i class="fas fa-sync"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="card-body table-bordered p-2">
                    <table #tb_fmgetFactor class="table table-hover table-striped table-head-fixed text-nowrap">
                        <thead>
                            <tr class="headText text-primary">
                                <th>เลขคำขอ</th>
                                <th>วันที่</th>
                                <th>โควตา</th>
                                <th>ชื่อชาวไร่</th>
                                <th>แปลง</th>
                                <th>รายการเบิกปุ๋ย</th>
                                <th class="text-right">จำนวน</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of fmgetFactorNow">
                                <td>{{ item.docid }}</td>
                                <td>{{ THtoLocalstr(item.datepost)}}</td>
                                <td>{{ item.fmcode }}</td>
                                <th>{{ item.fmname }}</th>
                                <td>{{ item.intlandno }}</td>
                                <td>{{ item.desc1 }}</td>
                                <td class="text-right">{{ item.amt1 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</div>
<app-footer></app-footer>